import * as React from 'react';

import type {SmtpPortType} from 'nutshell-graphql-types';

import {Hostname, Port, PortType} from './fields';

type Props = {
    hostname: string;
    portType: SmtpPortType;
    port: string;
    onChangeHostname: (arg1: string) => void;
    onChangePortType: (arg1: SmtpPortType) => void;
    onChangePort: (arg1: string) => void;
    onEnter: () => void;
};

export function SmtpFormServerFields(props: Props) {
    const handleChangePortType = (portType: SmtpPortType) => {
        props.onChangePortType(portType);

        if (portType === 'SSL') {
            props.onChangePort('465');
        } else {
            props.onChangePort('587');
        }
    };

    return (
        <React.Fragment>
            <Hostname
                value={props.hostname}
                onChange={props.onChangeHostname}
                onEnter={props.onEnter}
            />
            <PortType value={props.portType} onChange={handleChangePortType} />
            <Port value={props.port} onChange={props.onChangePort} onEnter={props.onEnter} />
        </React.Fragment>
    );
}
